import { h, FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as styles from '~src/styles/domains/outOfFilter/OutOfFilterPage.module.scss';
import { MAX_POLL_CALLS } from '~src/utils/constants';
import { trackPageMount } from '~src/utils/tracking';
import { Page } from '../common/enums/api';
import { general } from '../common/state/commonReducer';
import { brandSelector } from '../common/state/commonSelectors';

const OutOfFilterPage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const brand = useSelector(brandSelector);

  useEffect(() => {
    dispatch(trackPageMount(Page.OUT_OF_FILTER));
    dispatch(
      general({
        isOfferExpired: true,
        pollCallCount: MAX_POLL_CALLS,
      }),
    );
  }, []);

  return (
    <div className={styles['out-of-filter-body']}>
      <div className={`header-txt ${styles['out-of-filter-header']}`}>
        {t(`outOfFilter:${brand.toLowerCase()}.header`)}
      </div>
      <div className={styles['out-of-filter-text']}>
        <p>{t(`outOfFilter:${brand.toLowerCase()}.message`)}</p>
      </div>
    </div>
  );
};

export default OutOfFilterPage;
